import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { ReopenAttentionFindingsRequest } from '@/features/dashboard/attention/types/ReopenAttentionFindingsRequest.ts';
import { ResolveAttentionFindingsRequest } from '@/features/dashboard/attention/types/ResolveAttentionFindingsRequest.ts';

/**
 * Akcje na sprawach — wspólne dla panelu wyjazdu i panelu firmy.
 * Odczyt spraw wyjazdu zostaje w `tours/api/tourAttentionApi.ts`, bo jego klucz
 * zapytania siedzi pod korzeniem wyjazdu.
 */
const attentionApi = {
  resolve: async (request: ResolveAttentionFindingsRequest): Promise<void> => {
    await fetchPrivateApi<void>('POST', 'attention/findings/resolve', request);
  },
  reopenAttentionFindings: async (findingIds: string[]): Promise<void> => {
    const request: ReopenAttentionFindingsRequest = { findingIds };
    await fetchPrivateApi<void>('POST', 'attention/findings/reopen', request);
  },
};

export default attentionApi;
